/** True when the account call proves the saved login is no longer valid. A missing response is offline, not a logout. */
export function isStaleConsumerAuth(err: {code?: string; status?: number} | null | undefined): boolean {
  if (!err || err.status === 0) {
    return false;
  }
  return err.status === 401
    || err.code === 'CONSUMER_ACCOUNT_DELETED'
    || err.code === 'UNAUTHORIZED';
}
